import React, { Fragment, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';
import BuyButton from '../ComponentsBevego/BuyButton';
import FavouriteButton from '../ComponentsBevego/FavouriteButton';
import ContactAffiliateButton from '../ComponentsBevego/ContactAffiliateButton';
import ContactAffiliatePicker from '../ComponentsBevego/ContactAffiliatePickerDialog';
import AffiliateStock from '../ComponentsBevego/AffiliateStock';
import ProductQuantity from './ProductQuantity';

const VariantItems = () => {
    const variantItems = useSelector((state) => state.variantItems) || {};
    const [sorted, setSorted] = useState(false);
    function compareFunc(property, sortDirection, isAttributeSort) {
        let direction;
        if (isAttributeSort) {
            return function (a, b) {
                const attributeA = a["variantAttributes"].find(x => x.name === property).value;
                const attributeB = b["variantAttributes"].find(x => x.name === property).value;
                const compareA = parseFloat(attributeA) ? parseFloat(attributeA) : attributeA.toString();
                const compareB = parseFloat(attributeB) ? parseFloat(attributeB) : attributeB.toString();

                if (compareA > compareB) {
                    direction = 1;
                } else if (compareA < compareB) {
                    direction = -1;
                } else {
                    direction = 0;
                }

                return sortDirection === "asc" ? direction : -direction;
            }
        } else {
            return function (a, b) {
                const attributeA = a[property];
                const attributeB = b[property];
                const compareA = parseFloat(attributeA) ? parseFloat(attributeA) : attributeA.toString();
                const compareB = parseFloat(attributeB) ? parseFloat(attributeB) : attributeB.toString();

                if (compareA > compareB) {
                    direction = 1;
                } else if (compareA < compareB) {
                    direction = -1;
                } else {
                    direction = 0;
                }

                return sortDirection === "asc" ? direction : -direction;
            }
        }

    }

    const onHandleSort = (event, sortBy, isAttributeSort) => {
        const sortHeaders = document.querySelectorAll(".sort-header__container");
        const clickedEl = event.target.parentElement;
        let parentContainsAsc = false;
        let parentContainsDesc = false;
        let sortDirection;
        if (clickedEl.classList.contains('asc')) {
            parentContainsAsc = true;
            sortDirection = "desc";
        }
        else if (clickedEl.classList.contains('desc')) {
            parentContainsDesc = true;
            sortDirection = "asc";
        }
        else {
            parentContainsDesc = true;
            sortDirection = "asc";
        }

        for (let i = 0; i < sortHeaders.length; i++) {

            if (clickedEl !== sortHeaders[i]) {
                sortHeaders.forEach(el => el.classList.remove("desc"));
                sortHeaders.forEach(el => el.classList.remove("asc"));
                sortHeaders.forEach(el => el.classList.add("not--active"));
                if (parentContainsAsc) {
                    clickedEl.classList.add('desc');
                    clickedEl.classList.remove('not--active');
                }
                else if (parentContainsDesc) {
                    clickedEl.classList.add('asc');
                    clickedEl.classList.remove('not--active');
                }
            }
        }

        if (variantItems.model.variants) {
            variantItems.model.variants = variantItems.model.variants.sort(compareFunc(sortBy, sortDirection, isAttributeSort));
            setSorted(!sorted);
        }
    }
    const variantAttributeSize = variantItems.model && variantItems.model.productAttributes.length === 1
        ? "large-4"
        : variantItems.model.productAttributes.length === 2
        ? "large-2"
        : variantItems.model.productAttributes.length >= 3
        ? "large-1"
            : 'large-1';
    const buyButtonSize = variantItems.model.productAttributes.length === 3 ? "large-2" : "large-1";
    const VariantItem = useCallback(({ variant }) => {
        const priceModel = variant.priceExtension.price;

        return (
            <Fragment>
                <div itemScope itemType="http://schema.org/Product" className="row-inner product-detail-variants">
                    <meta itemProp="brand" content={variant.brand} />
                    <meta itemProp="description" content={variant.description} />
                    <meta itemProp="name" content={variant.name} />
                    {variant.priceExtension &&
                        variant.priceExtension.price.price != null &&
                        <meta itemProp="sku" content={variant.priceExtension.price.price.unitOfMeasurementTitle} />
                    }
                    <div className="small-12 columns">
                        <div className="row-inner product-detail__variant-info-row" itemProp="offers" itemScope itemType="http://schema.org/Offer">
                            <link itemProp="url" href={variant.url} />
                            <div className="small-12 large-3 columns product-detail__variant-info-row-name-container">
                                <a href={variant.url}>
                                    <h2 className="product-detail__variant-info-row-name">
                                        {variant.name}
                                    </h2>
                                </a>
                                <div className="product-detail__variant-info-row-article-number">
                                    {translate("product.articlenumber")} {variant.id}
                                </div>

                                {variant.isLoggedIn &&
                                    <div className="product-detail__stock-status-container">
                                        {variant.isInStock
                                            ? (
                                                <div className="product-detail__stock-status--in-stock" data-stockvariantid={variant.id}>
                                                    <link itemProp="availability" href="http://schema.org/InStock" />
                                                    <span><i className="fa-regular fa-circle-check"></i> {variant.stockStatusDescription} </span>
                                                </div>
                                            )
                                            : (
                                                <div className="product-detail__stock-status--out-of-stock" data-stockvariantid={variant.id}>
                                                    <link itemProp="availability" href="http://schema.org/OutOfStock" />
                                                    <span><i className="fa-regular fa-circle"></i> {variant.stockStatusDescription}</span>
                                                </div>
                                            )
                                        }
                                        <AffiliateStock variantId={variant.id} />
                                    </div>
                                }
                            </div>
                            {variant.variantAttributes &&
                                variant.variantAttributes.map((attribute, index) => (
                                    <div key={`${attribute}-${index}`} className={`small-12 ${variantAttributeSize} columns product-detail__variant-info-row-text-container text--center `}>
                                        <span className="hide-for-large product-detail__variant-info-row-text-heading">{attribute.name}:</span>
                                        {attribute.value}
                                    </div>
                                ))}

                            <div className="small-8 large-2 columns product-detail__variant-info-row-quantity-container text--center">
                                <div className="row product-detail__variant-info-quantity-wrapper">
                                    {variant.showQuantityField && variant.isLoggedIn && (
                                        <div className="product__quantity-container">
                                            <ProductQuantity quantityFieldId={variant.quantityFieldId}
                                                multipleValue={variant.multiple}
                                                inStockQuantity={variant.inStockQuantity}
                                                unitOfMeasurement={variant.unitOfMeasurement}
                                                decimalAmount={variant.decimalAmount} />
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="small-4 large-2 columns product-detail__variant-info-row-price-container text--center">
                                {variant.isLoggedIn && variant.priceExtension &&
                                    <div className="product-detail__price-info">
                                        {priceModel.price &&
                                            <Fragment>
                                                {priceModel.campaignPrice ?
                                                    <Fragment>
                                                        <span className="product__campaign-price">
                                                            {priceModel.campaignPrice}
                                                            {priceModel.campaignPrice.price}
                                                        </span>
                                                        <span className="product__old-price">
                                                            {priceModel.formattedPrice}
                                                        </span>
                                                    </Fragment>
                                                    :
                                                    <span className="price">
                                                        {priceModel.tierPrices.length > 0 ?
                                                            <Fragment>
                                                                {translate('product.pricefrom')}
                                                                {priceModel.formattedPrice}
                                                                {priceModel.price}
                                                            </Fragment>
                                                            :
                                                            <Fragment>
                                                                {priceModel.formattedPrice}
                                                            </Fragment>
                                                        }
                                                    </span>
                                                }
                                                <meta itemProp="price" content={priceModel.price} />
                                                <meta itemProp="priceCurrency" content={priceModel.currency.id} />
                                            </Fragment>
                                        }
                                    </div>
                                }
                            </div>
                            <div className={`small-12 ${buyButtonSize} columns product-detail__variant-info-row-button-container text--center`}>
                                <div className="product-detail__variant-info-buy-button-wrapper">
                                    {variant.isLoggedIn &&
                                        <Fragment>
                                            {variant.showContactAffiliate ?
                                                <Fragment>
                                                    <ContactAffiliateButton
                                                        label={''}
                                                        articleNumber={variant.id}
                                                        cssClass="button product-detail__contact-button icon-only" />
                                                </Fragment>
                                                :
                                                <BuyButton
                                                    {...{
                                                        label: '',
                                                        articleNumber: variant.id,
                                                        quantityFieldId: variant.quantityFieldId,
                                                        href: variant.url,
                                                        cssClass: "button product-detail__buy-button icon-only",
                                                    }}
                                                />
                                            }
                                        </Fragment>
                                    }
                                </div>
                                <div className="product-detail__variant-info-favourite-button-wrapper">
                                    {variant.isLoggedIn &&
                                        <FavouriteButton favouriteClass={variant.numberOfItemInList > 0 ? "is-favourite" : ""} articleNumber={variant.id} />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }, []);

    return (
        <div className="product-info__container product-detail__variant-info">
            <section className="tab">
                <div className="small-12 columns hide-for-small-only hide-for-medium-only">
                    <div className="row-inner product-detail__variant-info-header">
                        <div className="small-3 columns sort-header sort-header__name">
                            <span className="sort-header__container" onClick={(e) => onHandleSort(e, "name")}>
                                <span className="sort-heading" >{translate("code.product.info.name")}</span>
                                <i className={`fas fa-chevron-down sort-down`}></i>
                                <i className={`fas fa-chevron-up sort-up`}></i>
                            </span>
                        </div>
                        {variantItems.model.variants &&
                            variantItems.model.productAttributes &&
                            variantItems.model.productAttributes.map((attributeName, index) => (
                                <div
                                    key={`${index}-${attributeName}`}
                                    className={`${variantAttributeSize} columns text--center sort-header sort-header__${attributeName}`}
                                >
                                    <span className="sort-header__container" onClick={(e) => onHandleSort(e, attributeName, true)}>
                                        <span className="sort-heading">{attributeName}</span>
                                        <i className={`fas fa-chevron-down sort-down`}></i>
                                        <i className={`fas fa-chevron-up sort-up`}></i>
                                    </span>
                                </div>
                            )
                            )}

                        <div className="small-2 columns text--center sort-header no-sort">
                            {translate("code.product.info.amount")}
                        </div>
                        {variantItems.model.productItem && variantItems.model.productItem.isLoggedIn ?
                            <div className={`small-2 columns text--center sort-header sort-header__price`} >
                                <span className="sort-header__container" onClick={(e) => onHandleSort(e, "netPrice")}>
                                    <span className="sort-heading">{translate("code.product.info.total")}</span>
                                    <i className={`fas fa-chevron-down sort-down`}></i>
                                    <i className={`fas fa-chevron-up sort-up`}></i>
                                </span>
                            </div>
                            :
                            <div className="small-1 columns text--center sort-header no-sort">
                                {translate("code.product.info.total")}
                            </div>
                        }

                        <div className={`small-1 ${buyButtonSize} columns text--center sort-header no-sort`}>
                            {translate("code.product.info.buy")}
                        </div>
                    </div>
                </div>
                <section className="tab__content-container">
                    <div className="tab__content tab__content--small-padding">
                        {variantItems.model.variants && variantItems.model.variants.map((variant, index) => (
                            <VariantItem variant={variant} key={`${variant.id}-${index}`} />
                        ))}
                    </div>
                </section>
            </section>
            <ContactAffiliatePicker />
        </div>
    );
};

export default VariantItems;
